import { useColor } from "@commonlibs";
import clsx from "clsx";
import { config } from "common/config";
import { useNavigate } from "react-router-dom";
import { CircleHelpIcon, WhatsAppIcon } from "ui/common/icons";
import ExternalLink from "ui/router/components/ExternalLink/ExternalLink";
import { SupportButtonsIcon, SupportButtonsRoot } from "./SupportButtons.styles";
import { SupportButtonsProps } from "./SupportButtons.types";
import { HelpRoutes } from "ui/common/router/HelpRouter.types";

function SupportButtons({ className, color: colorProp = "primary", ...rest }: SupportButtonsProps) {
    const color = useColor(colorProp);
    const navigate = useNavigate();

    return (
        <SupportButtonsRoot className={clsx("support-buttons", className)} {...rest}>
            <SupportButtonsIcon css={{ color }} as={CircleHelpIcon} onClick={() => navigate(HelpRoutes.HELP)} />
            <ExternalLink href={config.whatsAppSupportLink}>
                <SupportButtonsIcon as={WhatsAppIcon} css={{ color }} />
            </ExternalLink>
        </SupportButtonsRoot>
    );
}

export default SupportButtons;
